import React, { useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { challenges } from "./challengesData";
import Prev from "./Prev";
import Next from "./Next";

const Challenges = () => {
  const [selected, setSelected] = useState(0);
  const handleSlideChange = (type) => {
    if (type === "prev") {
      if (selected === 0) {
        setSelected(challenges.length - 1);
      } else {
        setSelected(selected - 1);
      }
    } else {
      if (selected === challenges.length - 1) {
        setSelected(0);
      } else {
        setSelected(selected + 1);
      }
    }
  };
  
  return (
    <Container fluid style={{ background: "#e8f3ff" }}>
      <Container className="p-md-5 challenges">
        <Row>
          <Col className="d-flex flex-direction-column justify-content-center">
            <h5 className="text-lg">
              <span className="text-light-blue">Challenges</span>{" "}
              <span className="text-blue">
                in Managing Testing Lifecycles with Zephyr or TestRail
              </span>
            </h5>
            <p className="text-grey"  style={{fontSize: '18px'}}>
              As a Former Head of Testing, managing testing lifecycles with
              tools like Zephyr or TestRail revealed to me several challenges
              that directly impact test management efficiency, team
              productivity, and the alignment of testing with business goals.
              These challenges also highlight why these tools often fall short
              of demonstrating significant value beyond acting as basic test
              case repositories.
            </p>
            <div>
            <span
              className="btn-transparent btn-arrow"
              onClick={() => handleSlideChange("prev")}
            >
              <Prev/>
            </span>
            {" "}
            <span
              className="btn-transparent btn-arrow ml-4"
              onClick={() => handleSlideChange("next")}
            >
              <Next/>
            </span>
            </div>
            
          </Col>
          <Col>
            {challenges.map((challenge, index) => (
              <div
                className="p-5 mt-4 mt-md-2 mb-4 mb-md-0"
                key={challenge.title}
                style={{
                  background: `linear-gradient(135deg, #0a3d91, #1e72c0)`,
                  backgroundRepeat: "no-repeat",
                  backgroundPosition: "center",
                  backgroundOrigin: "center",
                  color: "white",
                  display: selected === index ? "block" : "none",
                  margin: "auto",
                  minHeight: "450px",
                }}
              >
                <h5 className="text-md">
                  {index + 1}. {challenge.title}
                </h5>
                <p className="text-std text-challenge">
                  <strong>Challenge: </strong>
                  {challenge.challenge}
                </p>
                <p className="text-std text-challenge">
                  <strong>Our Perspective: </strong>
                  {challenge.perspective}
                </p>
              </div>
            ))}
          </Col>
        </Row>
      </Container>
    </Container>
  );
};

export default Challenges;
